import productUtils from '@/core/productUtils'
const state = {
  tableLoading: false,
  // 项目信息
  project: {},
  // 项目产品
  projectProducts: [],
  // 聚合出来的项目品类列表
  projectCategoriesAgg: [],
  // 品类下的所有属性
  categoryAllProps: [],
  totalCount: 0,
  pageSize: 30,
  pageNo: 1,
}
const getters = {
  tableLoading: (state) => state.tableLoading,
  totalCount: (state) => state.totalCount,
  project: (state) => state.project,
  projectProducts: (state) => state.projectProducts,
  projectCategoriesAgg: (state) => state.projectCategoriesAgg,
  projectCategoriesTabs: (state) => {
    const categoriesAgg = state.projectCategoriesAgg
    const res = []
    categoriesAgg.forEach((item) => {
      if (item.count) {
        item.id = productUtils.judgeCategory(item.code)
        res.push(item)
      }
    })
    return res
  },
}
const mutations = {
  setTableLoading(state, data) {
    state.tableLoading = data
  },
  setTotalCount(state, data) {
    state.totalCount = data
  },
  setPageNo(state, data) {
    state.pageNo = data
  },
  setProject(state, data) {
    state.project = data
  },
  setProjectProducts(state, data) {
    // 直接对data做处理，就无需每次都遍历整个projectProducts
    const dataArr = []
    data.forEach((item) => {
      const category = productUtils.judgeCategory(item.gjwCategoryCode)
      const speed = category === 'fan' ? item.speedControl : null
      // 处理产品属性相关数据
      const productPropObj = productUtils.handleProductPropertiesData({
        productsData: item.productPropertyValues || [],
        category,
        speed,
        allProps: state.categoryAllProps
      })
      // 处理设计点属性相关数据
      const productDesignObj = productUtils.handleProductDesignOrRuntimeData(item.designProperties, category)
      const productRuntimeObj = productUtils.handleProductDesignOrRuntimeData(item.runtimeProperties, category)
      dataArr.push({
        // 标识该行是否处于正在编辑设计属性状态，编辑状态不允许点击查看和布置等按钮（这些按钮功能需要用到设计属性值）
        isEditing: false,
        ...item,
        ...productDesignObj,
        ...productRuntimeObj,
        ...productPropObj,
      })
    })
    if (state.pageNo === 1) {
      state.projectProducts = dataArr
    } else {
      state.projectProducts = [...state.projectProducts, ...dataArr]
    }
  },
  // 移除已选产品中的某一条数据
  removeProjectProductsData(state, { index }) {
    state.projectProducts.splice(index, 1)
  },
  setProjectCategoriesAgg(state, data) {
    state.projectCategoriesAgg = data
  },
  setCategoryAllProps(state, data) {
    state.categoryAllProps = data
  }

}
const actions = {
  // 获取当前项目信息
  async loadCurrentProject({ commit }) {
    try {
      const data = await this.$api.project.getCurrentProject()
      commit('setProject', data || {})
    } catch (error) {
      commit('setProject', {})
      console.error(error)
    }
  },
  // 获取项目下聚合的品类信息
  async loadProjectCategoriesAgg({ commit, state }) {
    try {
      const id = state.project.id
      if (!id && id !== 0) {
        console.error('缺少项目id')
        commit('setProjectCategoriesAgg', [])
        return
      }
      const data = await this.$api.project.getProjectCategoriesAgg(id)
      commit('setProjectCategoriesAgg', data || [])
    } catch (error) {
      commit('setProjectCategoriesAgg', [])
      console.error(error)
    }
  },
  // 获取项目下的产品列表-分页; payload中页码相关入参已在此统一处理好了
  async loadProjectProducts({ commit, state }, payload = {}) {
    try {
      const id = state.project.id
      if (!id && id !== 0) {
        console.error('缺少项目id')
        return
      }
      const pageNo = state.pageNo
      const pageSize = state.pageSize
      payload = {
        ...payload,
        page_no: pageNo,
        page_size: pageSize,
      }
      if (pageNo === 1) {
        commit('setTableLoading', true)
        commit('setProjectProducts', [])
        commit('setTotalCount', 0)
      }
      const data = await this.$api.project.getProductList(id, payload)
      commit('setProjectProducts', data.list || [])
      commit('setTotalCount', data.totalCount || 0)
      commit('setPageNo', pageNo + 1)
      commit('setTableLoading', false)
      // 已选产品查询埋点
      this.$tracks({
        event: 'selectedProductQuery',
        params: {
          g_c_class_code: payload.gjw_category_code,
          g_c_selection_project_id: id,
        }
      })
    } catch (error) {
      commit('setProjectProducts', [])
      commit('setTableLoading', false)
      console.error(error)
    }
  },

}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
